var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbpur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0134 37.8097V20.7597H27.7341L28.5923 14.1131H22.0134V9.87015C22.0134 7.94639 22.5454 6.63538 25.3072 6.63538L28.8239 6.63393V0.688938C28.2157 0.609906 26.1281 0.428711 23.6984 0.428711C18.6247 0.428711 15.1511 3.52566 15.1511 9.21187V14.1131H9.41309V20.7597H15.1511V37.8097H22.0134Z",
    fill: "#6020BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_3305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.381,
    height: 37.381,
    fill: "white",
    transform: "translate(0.428711 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbpur);
export default __webpack_public_path__ + "static/media/fbpur.cabb25de88bc55c3347e53459b2f2cbe.svg";
export { ForwardRef as ReactComponent };